import React from 'react';
import './components.css';
import resume from '../data/resume.pdf';


function CV() {
    return (
        <section className='tile tile-resume' id='resume'>
            <div className='resume-top'>
                <h2 className='tile-label'>Resume 📄</h2>
                <a className='text-link resume-save' href={resume} target="_blank" rel="noopener noreferrer">
                    Save PDF ↗
                </a>
            </div>

            <div className='resume-block'>
                <h3>Education</h3>
                <div className='resume-item'>
                    <div className='resume-when'>2024</div>
                    <div>
                        <p className='resume-role'>Ph.D. in Computer Science</p>
                        <p className='resume-place'>Washington University in St. Louis</p>
                        <p className='resume-note'>Advisor: Alvitta Ottley. Dissertation: <em>Towards Building a Reliable Human-Machine Partnership — A Visual Analytics Approach</em>.</p>
                    </div>
                </div>
                <div className='resume-item'>
                    <div className='resume-when'>2023</div>
                    <div>
                        <p className='resume-role'>M.S. in Computer Science</p>
                        <p className='resume-place'>Washington University in St. Louis</p>
                    </div>
                </div>
                <div className='resume-item'>
                    <div className='resume-when'>2019</div>
                    <div>
                        <p className='resume-role'>B.A. in Computer Science</p>
                        <p className='resume-place'>New College of Florida</p>
                    </div>
                </div>
            </div>

            <div className='resume-block'>
                <h3>Experience</h3>
                <div className='resume-item'>
                    <div className='resume-when'>2024 – now</div>
                    <div>
                        <p className='resume-role'>Lead Research Scientist, Visual Analytics &amp; UI/UX</p>
                        <p className='resume-place'>Epsilon · Chicago, IL</p>
                        <ul>
                            <li>Designed and launched an AI-powered analytics interface for generating, summarizing, and structuring insights through natural language and intelligent recommendations.</li>
                            <li>Integrated conversational AI into data workflows so people can explore data, refine visualizations, and build narrative reports with less manual effort.</li>
                            <li>Built a recommendation system for data views that increased user-generated insights by 32% and new-user engagement by 44%.</li>
                            <li>Simplified complex workflows and improved navigation in a web-based analytics platform.</li>
                            <li>Mentored a summer intern on user session modeling and a dashboard for monitoring usage, system behavior, and error states.</li>
                        </ul>
                    </div>
                </div>
                <div className='resume-item'>
                    <div className='resume-when'>2019 – 2024</div>
                    <div>
                        <p className='resume-role'>Graduate Research Assistant</p>
                        <p className='resume-place'>VIBE Lab · Washington University in St. Louis</p>
                        <ul>
                            <li>Built interactive visual analytics systems that combine user interaction with machine learning for real-time data exploration.</li>
                            <li>Studied trust, bias, and transparency in AI-guided visual interfaces, with findings recognized at EuroVis 2024.</li>
                        </ul>
                    </div>
                </div>
                <div className='resume-item'>
                    <div className='resume-when'>2018</div>
                    <div>
                        <p className='resume-role'>Data Visualization Research Intern</p>
                        <p className='resume-place'>Big Data Analytics REU · Washington University in St. Louis</p>
                        <ul>
                            <li>Designed a D3.js dashboard for optimized smart-home energy schedules, with direct manipulation that updated hourly cost and usage in real time.</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className='resume-block'>
                <h3>Skills</h3>
                <p className='resume-skills'><span>Languages</span> Python, TypeScript, JavaScript, HTML, CSS, R, Java</p>
                <p className='resume-skills'><span>Visualization &amp; UI</span> D3.js, React, Plotly</p>
                <p className='resume-skills'><span>Data &amp; ML</span> NumPy, Pandas, Scikit-Learn</p>
                <p className='resume-skills'><span>Backend</span> Node.js, Flask, PostgreSQL</p>
            </div>

            <div className='resume-block last'>
                <h3>Honors</h3>
                <div className='resume-item'>
                    <div className='resume-when'>2024</div>
                    <div>
                        <p className='resume-role'>Honorable Mention, EuroVis</p>
                        <p className='resume-place'>Guided By AI: Navigating Trust, Bias, and Data Exploration in AI-Guided Visual Analytics</p>
                    </div>
                </div>
                <div className='resume-item'>
                    <div className='resume-when'>2019</div>
                    <div>
                        <p className='resume-role'>Dean’s Select Fellowship</p>
                        <p className='resume-place'>Washington University in St. Louis</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CV;
